<template>
    <div class="d-flex gap-4 flex-column">

        <Card :header="$t('currentAvailability')" overlay :loading="loading">

            <template #nav>
                <div :key="spaceId" class="d-flex gap-3 flex-column">
                    <div class="d-flex gap-3">
                        <Multiselect
                            :fetch-options-function="fetchOfferAvailabilities"
                            :placeholder="$t('availabilityTime')"
                            :selected-options-label="$t('selectedAvailabilities')"
                            searchable
                            track-by="value"
                            label="label"
                            select-label=""
                            :disabled="loading"
                            show-checkboxes
                            show-selected
                            multiple
                            preselect-all
                            :close-on-select="false"
                            :clear-on-select="false"
                            class="width-200"
                            @changeTrackBy="availabilities = $event"
                            @loading="offerAvailabilitiesLoading = $event"
                        />
                        <MultiselectAvailableCampaigns :disabled="loading" @changeTrackBy="campaigns = $event" @loading="campaignsLoading = $event" />
                        <Multiselect
                            v-show="showProductGroupsResults"
                            :key="spaceId"
                            :fetch-options-function="fetchSpaceGroups"
                            :placeholder="$t('productGroup')"
                            :selected-options-label="$t('selectedGroups')"
                            searchable
                            track-by="id"
                            label="name"
                            select-label=""
                            :disabled="loading"
                            show-checkboxes
                            show-selected
                            multiple
                            preselect-all
                            :close-on-select="false"
                            :clear-on-select="false"
                            class="width-200"
                            @changeTrackBy="groups = $event"
                            @loading="spaceGroupsLoading = $event"
                        />
                        <FormCategoryTreeSelect
                            v-show="!showProductGroupsResults"
                            ref="FormCategoryTreeSelect"
                            v-model="categories"
                            :disabled="loading"
                            class="width-200"
                            preselect
                            prevent-empty-selection
                            :clearable="false"
                            @loading="categoriesLoading = $event"
                        />
                    </div>
                    <div class="d-flex gap-3 justify-content-end align-items-center">
                        <b-form-checkbox v-model="showProductGroupsResults" switch>{{ $t('showResultsForProductGroups') }}</b-form-checkbox>
                    </div>
                </div>
            </template>

            <div class="dropdown-divider border-bottom border-light"></div>

            <div class="d-flex gap-4 flex-column">

                <CurrentProductsAvailability />

                <div class="dropdown-divider border-bottom border-light"></div>

                <CurrentUnavailableProducts />

            </div>

        </Card>

    </div>
</template>



<script>
    import FormCategoryTreeSelect from '@/components/common/FormCategoryTreeSelect.vue';
    import Multiselect from '@/components/common/Multiselect.vue';
    import MultiselectAvailableCampaigns from '@/components/common/MultiselectAvailableCampaigns.vue';
    import CurrentProductsAvailability from './CurrentProductsAvailability.vue';
    import CurrentUnavailableProducts from './CurrentUnavailableProducts.vue';

    export default {
        name: 'CurrentAvailability',
        components: {
            Multiselect,
            FormCategoryTreeSelect,
            CurrentProductsAvailability,
            CurrentUnavailableProducts,
            MultiselectAvailableCampaigns,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                requestCurrentProductsAvailability: this.$req('space/CurrentProductsAvailability'),
                requestCurrentUnavailableProducts: this.$req('space/CurrentUnavailableProducts'),
                requestSpaceGroups: this.$req('producerProductGroups/SpaceGroups'),
                requestOfferAvailabilities: this.$req('offers/OfferAvailabilities'),
                showProductGroupsResults: false,
                campaigns: [],
                groups: [],
                categories: [],
                offerAvailabilitiesLoading: false,
                campaignsLoading: false,
                spaceGroupsLoading: false,
                categoriesLoading: false,
            };
        },
        computed: {
            loadingFilters() {
                return this.campaignsLoading || this.spaceGroupsLoading || this.categoriesLoading;
            },
            loading() {
                return this.requestCurrentProductsAvailability.getLoading() || this.requestCurrentUnavailableProducts.getLoading() || this.loadingFilters;
            },
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            apiParams() {
                const urlParams = { spaceId: this.spaceId };
                const requestParams = {};
                if (this.campaigns?.length) requestParams.campaigns = this.campaigns.join(',');
                if (!this.showProductGroupsResults && this.categories?.length) requestParams.categories = this.categories.join(',');
                if (this.showProductGroupsResults && this.groups?.length) requestParams.groups = this.groups.join(',');
                return { urlParams, requestParams };
            },
        },
        watch: {
            spaceId() {
                this.showProductGroupsResults = false;
                this.campaigns = [];
                this.groups = [];
                this.categories = [];
                this.offerAvailabilitiesLoading = false;
            },
            apiParams: {
                handler(newVal, oldVal) {
                    if (JSON.stringify(newVal || {}) !== JSON.stringify(oldVal || {})) {
                        this.loadData();
                    }
                },
            },
        },
        methods: {
            loadData() {
                if (!this.loadingFilters) {
                    this.resetData();
                    this.fetchData();
                }
            },
            resetData() {
                this.requestCurrentProductsAvailability.reset();
                this.requestCurrentUnavailableProducts.reset();
            },
            fetchData() {
                this.requestCurrentProductsAvailability.get(this.apiParams);
                this.requestCurrentUnavailableProducts.get(this.apiParams);
            },
            fetchOfferAvailabilities() {
                return this.requestOfferAvailabilities.get();
            },
            fetchSpaceGroups() {
                return this.requestSpaceGroups.get({ urlParams: { spaceId: this.spaceId } }).then(data => data.items);
            },
        },
    };
</script>
